import React from "react";
import { IColumn } from "./Table";

interface TableHeaderProps<T, K extends keyof T> {
  columns: IColumn<T, K>[];
  hasAction: boolean;
}

export const TableHeader = <T, K extends keyof T>({ columns, hasAction }: TableHeaderProps<T, K>) => {
  const hasHeader = columns.some((col) => Boolean(col.title));

  if (!hasHeader) return null;

  return (
    <thead>
      <tr>
        {columns.map((column, index) => (
          <th key={index} scope="col" align={column.align || "left"} style={{ width: column.width }}>
            {column.title}
          </th>
        ))}
        {hasAction && <th id="action" aria-label="action" />}
      </tr>
    </thead>
  );
};
